import { render, staticRenderFns } from "./MainChartPemohon.vue?vue&type=template&id=b48e86e6&"
import script from "./MainChartPemohon.vue?vue&type=script&lang=js&"
export * from "./MainChartPemohon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports